import { getContrastColor } from '../../utils/getContrastColor';
import takoColors from '../../theme/colors';

export const chartjsColors = {
    color1: takoColors.P100,
    color2: takoColors.F300,
    color3: takoColors.O250,
    color4: takoColors.P300,
    color5: takoColors.B300,
    color6: takoColors.R200,
    average: takoColors.R600,
    grid: takoColors.N30,
    text: takoColors.N900,
    axisLabel: takoColors.P300,
    tooltipBg: takoColors.N900,
};

export const chartjsFont = {
    family: "'Work Sans', 'Noto Sans', helvetica, arial, sans-serif",
    size: 16,
    weight: 400,
};

export const chartjsPlugins = {
    datalabels: {
        color: (ctx: {
            dataset: { backgroundColor: string };
            dataIndex: number;
        }) => {
            const bgColor = ctx.dataset.backgroundColor;
            const index = ctx.dataIndex;
            const rawColor = Array.isArray(bgColor) ? bgColor[index] : bgColor;
            return getContrastColor(rawColor);
        },
        anchor: 'center',
        align: 'center',
    },
    legend: {
        position: 'right',
        labels: { padding: 16 },
        title: {
            position: 'start',
            font: { size: 18 },
        },
    },
    tooltip: {
        backgroundColor: chartjsColors.tooltipBg,
    },
};

export const chartjsOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: chartjsPlugins,
};
